import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { getUrlWithVersion } from '../../../api/api'
import { ILogSource } from '../../../types/logs'

export const fetchLogSources = createAsyncThunk<
    { productGuid: string; logSources: ILogSource[] } | void,
    { productGuid: string },
    ThunkConfig<string>
>('logsSlice/fetchLogSources', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { productGuid } = args
    try {
        const { data } = await api.get<Record<'log_targets', ILogSource[]>>(
            getUrlWithVersion(`/logs/${productGuid}/sources`)
        )
        if (!data  || !Array.isArray(data?.log_targets)) {
            const error = new Error('Received log sources in wrong format')
            console.error(error)
            return
        }

        return { productGuid, logSources: data.log_targets }
    } catch (e) {
        console.error(e)
        return rejectWithValue('Failed to fetch log sources')
    }
})
